import { Grid, IconButton, useTheme } from "@mui/material";
import { MentionsInput, Mention } from 'react-mentions';
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store";
import { useEffect, useRef, useState } from "react";
import ImageProfileCircle from "../../../components/ImageProfileCircle";

import CloseIcon from '@mui/icons-material/Close';
import { searchCompanyEmployees } from "../../../store/slices/userRequests";

// import { Mention } from 'primereact/mention';

import 'primereact/resources/themes/saga-blue/theme.css';  // Puedes cambiar 'saga-blue' por otro tema
import 'primereact/resources/primereact.min.css';  // Importa los estilos base de PrimeReact

import "./postInputBar.css"

interface PostInputBarProps {
    inputText: string;
    setInputtext: (inputText: string) => void;
    loading: boolean;
    mentions: any[];
    setMentions: (suggestion: any) => void;
}

const PostInputBar = ({inputText, setInputtext, loading, mentions, setMentions}: PostInputBarProps) => {

    const theme = useTheme();
    // const {sessionData} = useSelector((state: RootState) => state.auth);
    // const [focused, setFocused] = useState(false);

    return (

        <Grid container item width={"100%"} direction={"row"}>
            {/* <ImageProfileCircle 
                width="3rem"
                height="3rem"
                userId={sessionData?.UserId}
                userName={sessionData?.FullName}
            /> */}
            <Grid 
                item
                style={{
                    alignContent: "center",
                    alignItems: "center",
                    flex: 1,
                    width: "100%",
                    marginTop: ".5rem",
                    // marginLeft: ".5rem"
                }}
            >
                <TweetField 
                    mentions={mentions}
                    setMentions={setMentions}
                    inputText={inputText} 
                    setInputtext={setInputtext} 
                    loading={loading} 
                />
            </Grid>
            {(inputText) && <Grid item style={{ width: "1.5rem", padding: "0"}}>
                <IconButton disabled={inputText === ""} onClick={loading ? undefined : () => setInputtext("")}>
                    <CloseIcon style={{color: theme.s10palette.S10Blueblue600}} />
                </IconButton>
            </Grid>}
        </Grid>
    )
}


const TweetField = ({ inputText, setInputtext, mentions, setMentions }: PostInputBarProps) => {
    
    const dispatch = useDispatch<AppDispatch>();
    const { employees, loading } = useSelector((state: RootState) => state.userRequests).companyEmployees;
    const { connectionId, companyselected } = useSelector((state: RootState) => state.auth);
    
    const [searchValue, setSearchValue] = useState<string>("");

    const callbackRef = useRef<any>();
    const debounceTimeoutRef = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
        if (!connectionId || !companyselected || searchValue === "") {
            return;
        }
        if (debounceTimeoutRef.current) {
            clearTimeout(debounceTimeoutRef.current);
        }
        debounceTimeoutRef.current = setTimeout(() => {
            dispatch(searchCompanyEmployees(companyselected.RUC, 5, 1, searchValue));
        }, 250);
        return () => {
            if (debounceTimeoutRef.current) {
                clearTimeout(debounceTimeoutRef.current);
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [connectionId, companyselected, searchValue]);

    useEffect(() => {
        if (loading || !callbackRef.current) {
            return;
        }
        callbackRef.current(employees.map(e => ({...e, id: e.CodIdentificador, display: e.Descripcion })));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [employees, loading]);

    const handleSelectSuggestion = (inputMentions: any[]) => {
        const newMentions = [...mentions];
        for (let i = 0; i < inputMentions.length; i++) {
            const mentionExists = newMentions.find((fs: any) => fs.Descripcion === inputMentions[i].display);
            if (!mentionExists) {
                const employeeData = employees.find((fs: any) => fs.Descripcion === inputMentions[i].display);
                newMentions.push(employeeData);
            }
        }
        setMentions(newMentions);
    };

    return (
      <div style={{ position: "relative", width: "100%" }}>
        <MentionsInput
          value={inputText}
          className="mentionSuggestions"
          style={{
            input: {
              minHeight: '32px',
              outline: 'none',
              width: '100%',
              borderRadius: '6px',
              fontSize: "1rem",
              display: 'block',
              lineHeight: 1.5,
              padding: '0.5rem',
            },
            suggestions: {
              list: {
                position: 'absolute',
                // top: '100%',
                top: "7px",
                left: "-50px",
                backgroundColor: '#fff',
                border: '1px solid rgba(0,0,0,0.15)',
                fontSize: 14,
                zIndex: 1000,  // Ensure it's above other elements
              },
              item: {
                padding: '5px 15px',
                minWidth: "300px",
                backgroundColor: '#fff',
                borderBottom: '1px solid rgba(0,0,0,0.15)',
                '&focused': {
                  backgroundColor: '#cee4e5',
                },
              },
            },
          }}
          onChange={(e, newValue, newPlaneText, mentions) => {
            handleSelectSuggestion(mentions);
            setInputtext(e.target.value);
          }}
          placeholder="Publicar..."
          a11ySuggestionsListLabel="What's happened?"
        >
          <Mention
            trigger="@"
            isLoading={loading}
            data={(search, callback) => {
              setSearchValue(search);
              callbackRef.current = callback;
            }}
            style={{
              backgroundColor: '#cee4e5',
              fontWeight: "bold",
            }}
            markup="@[__display__](__id__)"
            renderSuggestion={(user: any) => {
              return (
                <Grid container direction="row" alignItems="flex-start" wrap="nowrap" >
                  <Grid item style={{ marginRight: '.25rem', flexShrink: 0 }}>
                    <ImageProfileCircle
                      height="1.5rem"
                      width="1.5rem"
                      ruc={user.ruc}
                      userName={user.Descripcion}
                      userId={user.createdById}
                    />
                  </Grid>
                  <Grid item xs style={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}>
                    {user.Descripcion}
                  </Grid>
                </Grid>
              );
            }}
          />
        </MentionsInput>
      </div>
    );
};


export default PostInputBar;